import React from 'react';
import fallbackManager from '../utils/fallbackManager';

const FallbackStatusIndicator = () => {
  const [isVisible, setIsVisible] = React.useState(false);
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    const checkFallbackStatus = () => {
      if (fallbackManager.isFallbackMode) {
        setIsVisible(true);
        setMessage(fallbackManager.getFallbackMessage());
      } else {
        setIsVisible(false);
      }
    };

    // Check immediately
    checkFallbackStatus();

    // Check every 5 seconds
    const interval = setInterval(checkFallbackStatus, 5000);

    return () => clearInterval(interval);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        backgroundColor: '#ff6b35',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        fontWeight: 'bold',
        zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        animation: 'pulse 2s infinite'
      }}
    >
      ⚠️ {message}
      <style jsx>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.7; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default FallbackStatusIndicator;
